const API_URL = "http://localhost/tavpos/backend/pagos.php?property=template";
   export default API_URL;

 export const API_REVENU_LAYOUT = "https://bts.ei-solutions.co/shopeis/script/generated/api/layout.php";   

 export const API_NOMBREMESA = "https://bts.ei-solutions.co/tavpos/backend/update_nommesa.php";

 export const API_REF_LESPERA = "https://bts.ei-solutions.co/tavpos/backend/update_ref_lespera.php";